import { useMemo } from 'react';

export function useEmbed(): boolean {
  return useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('embed') === 'true') return true;
    try {
      return window.self !== window.top;
    } catch {
      return true;
    }
  }, []);
}

export function navigateTop(url: string) {
  try {
    if (window.top) {
      window.top.location.href = url;
    } else {
      window.location.href = url;
    }
  } catch {
    window.location.href = url;
  }
}
